import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { PhysicalMappingState } from "../../../types";
import { axiosObj } from "../../../../config/apiClients";
import { PhysicalMapping } from "../../../../utils/types";

const initialState: PhysicalMappingState = {
  isLoading: false,
  physicalStocks: [],
  physicalMappings: [],
  pagination: {
    currentPage: 1,
    totalPages: 1,
    hasNextPage: false
  }
};

export const getPhysicalStocks = createAsyncThunk(
  "/neo/v2/physicalMapping/getPhysicalStocks",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosObj.get("neo/v2/physicalMapping/getPhysicalStocks");
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Fetch Physical Stocks' });
    }
  }
);

export const createPhysicalMapping = createAsyncThunk(
  "/neo/v2/physicalMapping/getAllPhysicalMapping",
  async (physicalMapping: PhysicalMapping, { rejectWithValue }) => {
    try {
      const response = await axiosObj.post("neo/v2/physicalMapping/create", physicalMapping);
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to create Physical Mapping' });
    }
  }
);

export const updatePhysicalMapping = createAsyncThunk(
  "/neo/v2/physicalMapping/update",
  async (physicalMapping: PhysicalMapping, { rejectWithValue }) => {
    try {
      const response = await axiosObj.patch("neo/v2/physicalMapping/update", { ...physicalMapping, id: physicalMapping._id });
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to update Physical Mapping' });
    }
  }
);

export const deletePhysicalMapping = createAsyncThunk(
  "/neo/v2/physicalMapping/delete",
  async (physicalMappingId: string, { rejectWithValue }) => {
    try {
      const response = await axiosObj.delete("neo/v2/physicalMapping/delete", { data: { physicalMappingId } });
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to delete Physical Mapping' });
    }
  }
);

export const getAllPhysicalMapping = createAsyncThunk(
  "/neo/v2/physicalMapping/getAll",
  async (_, { rejectWithValue }) => {
    try {
      const response = await axiosObj.get("neo/v2/physicalMapping/getAll");
      return response.data;
    } catch (error) {
      return rejectWithValue(error || { message: 'Failed to Fetch Physical Mapping' });
    }
  }
);

const physicalMappingSlice = createSlice({
  name: "physicalMappings",
  initialState,
  reducers: {
    removePhysicalMapping: (state, action) => {
      const id = action.payload;
      state.physicalMappings = state.physicalMappings.filter((item) => item._id !== id);
    },
    resetPhysicalMappingState: (state) => {
      state.isLoading = false;
      state.physicalMappings = [];
      state.pagination = {
        currentPage: 1,
        totalPages: 1,
        hasNextPage: false
      };
    }
  },
  extraReducers(builder) {
    builder
      .addCase(getPhysicalStocks.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getPhysicalStocks.fulfilled, (state, action) => {
        state.isLoading = false;
        state.physicalStocks = action.payload.payload.kAllPhysicalStocks;
      })
      .addCase(getPhysicalStocks.rejected, (state) => {
        state.isLoading = false;
        state.physicalStocks = [];
      })
      .addCase(getAllPhysicalMapping.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(getAllPhysicalMapping.fulfilled, (state, action) => {
        state.isLoading = false;
        state.physicalMappings = action.payload.payload.allPhysicalMappings;
      })
      .addCase(getAllPhysicalMapping.rejected, (state) => {
        state.isLoading = false;
        state.physicalMappings = [];
      });
  }
})

export const { resetPhysicalMappingState, removePhysicalMapping } = physicalMappingSlice.actions;

export default physicalMappingSlice.reducer;